import { Title, Card, Flex, Stack, Alert } from '@mantine/core';
import { BaseRecord } from '@refinedev/core';
import { IconExclamationCircle } from '@tabler/icons-react';

import {
  MRT_EditActionButtons,
  MRT_Row,
  MRT_TableInstance,
} from 'mantine-react-table';
import React from 'react';

interface CreateModalProps<TData extends BaseRecord> {
  type: string;
  row: MRT_Row<TData>;
  table: MRT_TableInstance<TData>;
  internalEditComponents?: React.ReactNode[];
  alertModal?: boolean;
}

export const CreateModal = <TData extends BaseRecord>({
  type,
  row,
  table,
  internalEditComponents = [],
  alertModal = false,
}: CreateModalProps<TData>) => {
  return (
    <Stack data-testid={`create-${type}-modal`}>
      <Title order={3} data-testid={`create-${type}-title`}>
        Create {type}
      </Title>
      {alertModal ? (
        <Alert
          icon={<IconExclamationCircle />}
          title="Form Errors"
          color={'red'}
          children={'Fix the form errors to submit.'}
          withCloseButton
          closeButtonLabel="Close alert"
          data-testid="alertModal"
        />
      ) : (
        <></>
      )}
      <Card shadow="md" radius="md" padding="md">
        {internalEditComponents}
      </Card>
      <Flex justify="end">
        <MRT_EditActionButtons row={row} table={table} variant="text" />
      </Flex>
    </Stack>
  );
};
